(function (root) {
  'use strict';
  if (root.OxxEngineerContextBridgeV2) return;

  var MAX_TEXT = 500;
  function clean(value, max) {
    return String(value == null ? '' : value).replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max || MAX_TEXT);
  }
  function positive(value) {
    return /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(String(value || '').trim()) && Number(value) > 0;
  }
  function parseContext(search) {
    var p = new URLSearchParams(search || '');
    var unit = clean(p.get('unit') || p.get('units'), 8).toLowerCase();
    unit = unit === 'in' || unit === 'inch' ? 'in' : unit === 'mm' ? 'mm' : '';
    var ctx = {
      source: clean(p.get('source'), 120),
      id: clean(p.get('id'), 24),
      cs: clean(p.get('cs'), 24),
      unit: unit,
      material: clean(p.get('material'), 120),
      hardness: clean(p.get('hardness'), 80),
      media: clean(p.get('media'), 300),
      temperature: clean(p.get('temperature'), 200),
      pressure: clean(p.get('pressure'), 200),
      motion: clean(p.get('motion'), 160),
      application: clean(p.get('application'), 500),
      context: clean(p.get('context'), 1500),
      hardware: clean(p.get('hardware'), 500),
      special: clean(p.get('special'), 500),
      product: clean(p.get('product'), 160),
      product_id: clean(p.get('product_id'), 24),
      variant: clean(p.get('variant'), 24),
      sku: clean(p.get('sku'), 120),
      standard: clean(p.get('standard'), 80),
      standard_code: clean(p.get('standard_code'), 40),
      standard_class: clean(p.get('standard_class'), 8),
      quantity: clean(p.get('quantity'), 10),
      resolution_context_id: clean(p.get('resolution_context_id'), 160)
    };
    if (!positive(ctx.id)) ctx.id = '';
    if (!positive(ctx.cs)) ctx.cs = '';
    return ctx;
  }
  function setNativeValue(el, value) {
    if (!el) return false;
    var proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (!desc || !desc.set) return false;
    if (String(el.value) === String(value)) return true;
    desc.set.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    el.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    return true;
  }
  function openPanel(shadow, label) {
    var button = Array.from(shadow.querySelectorAll('button')).find(function (b) {
      return clean(b.textContent, 100) === label;
    });
    if (!button) return false;
    if (button.getAttribute('aria-expanded') !== 'true') button.click();
    return true;
  }
  function chooseUnit(shadow, unit) {
    if (!unit) return false;
    var aria = unit === 'in' ? 'Use inches' : 'Use millimetres';
    var button = shadow.querySelector('button[aria-label="' + aria + '"]');
    if (!button) return false;
    if (button.getAttribute('aria-pressed') !== 'true') button.click();
    return true;
  }
  function findMaterialOption(select, requested) {
    if (!select || !requested) return null;
    var aliases = {
      'BUNA-N': 'NBR', 'BUNA N': 'NBR', 'NITRILE': 'NBR',
      'VITON': 'FKM', 'VITON®': 'FKM',
      'VMQ': 'SILICONE', 'SIL': 'SILICONE'
    };
    var want = clean(requested, 80).toUpperCase();
    want = aliases[want] || want;
    return Array.from(select.options).find(function (o) {
      var value = clean(o.value, 80).toUpperCase();
      var text = clean(o.textContent, 160).toUpperCase();
      return value === want || text === want || text.indexOf(want + ' ') === 0 || text.indexOf(want + ' (') === 0;
    }) || null;
  }
  function findHardnessOption(select, requested) {
    if (!select || !requested) return null;
    var want = clean(requested, 20).toUpperCase().replace(/\s*SHORE\s*A$/i, '').replace(/A$/i, '').trim();
    return Array.from(select.options).find(function (o) {
      var value = clean(o.value, 20).toUpperCase().replace(/A$/i, '');
      var text = clean(o.textContent, 80).toUpperCase().replace(/\s*SHORE\s*A$/i, '').replace(/A$/i, '').trim();
      return value === want || text === want;
    }) || null;
  }
  function clearExampleEngineeringDefaults(shadow, ctx) {
    if (!ctx.id && !ctx.cs) return;
    ['#field-bore','#field-shaft','#field-grooveDepth','#field-installedDiameter','#field-grooveWidth'].forEach(function (sel) {
      var el = shadow.querySelector(sel);
      if (el) setNativeValue(el, '');
    });
    openPanel(shadow, 'Advanced settings');
    ['#field-temperature','#field-pressure'].forEach(function (sel) {
      var el = shadow.querySelector(sel);
      if (el) setNativeValue(el, '');
    });
  }
  function applyContext(shadow, ctx) {
    var applied = { size: false, unit: false, material: false, hardness: false };
    chooseUnit(shadow, ctx.unit);
    applied.unit = Boolean(ctx.unit);
    if (ctx.id || ctx.cs) clearExampleEngineeringDefaults(shadow, ctx);
    if (ctx.id) applied.size = setNativeValue(shadow.querySelector('#field-ringId'), ctx.id) || applied.size;
    if (ctx.cs) applied.size = setNativeValue(shadow.querySelector('#field-cs'), ctx.cs) || applied.size;

    if (ctx.material || ctx.hardness) openPanel(shadow, 'Advanced settings');
    var material = shadow.querySelector('#field-material');
    var materialOpt = findMaterialOption(material, ctx.material);
    if (materialOpt) applied.material = setNativeValue(material, materialOpt.value);
    var hardness = shadow.querySelector('#field-hardness');
    var hardnessOpt = findHardnessOption(hardness, ctx.hardness);
    if (hardnessOpt) applied.hardness = setNativeValue(hardness, hardnessOpt.value);
    return applied;
  }
  function mergeQuoteContext(href, ctx, applied, touched) {
    var url = new URL(href || '/pages/bulk-quote', location.origin);
    touched = touched || {};
    if (ctx.source && ctx.source !== 'engineer-pro') url.searchParams.set('origin_source', ctx.source);
    if (ctx.material && !touched.material) url.searchParams.set('material', ctx.material);
    if (ctx.hardness && !touched.hardness) url.searchParams.set('hardness', ctx.hardness);
    if (ctx.temperature && !touched.temperature) url.searchParams.set('temperature', ctx.temperature);
    if (ctx.pressure && !touched.pressure) url.searchParams.set('pressure', ctx.pressure);
    if (!ctx.temperature && !touched.temperature) url.searchParams.delete('temperature');
    if (!ctx.pressure && !touched.pressure) url.searchParams.delete('pressure');
    // Engineer inputs explicitly use Celsius and MPa; preserve unknown incoming units.
    [['temperature', '\u00b0C'], ['pressure', 'MPa']].forEach(function (entry) {
      if (!touched[entry[0]]) return;
      var valueKey = entry[0] + 'Value';
      var value = clean(Object.prototype.hasOwnProperty.call(touched, valueKey) ? touched[valueKey] : url.searchParams.get(entry[0]), 200);
      if (/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) {
        url.searchParams.set(entry[0], value + ' ' + entry[1]);
      } else if (!value) {
        url.searchParams.delete(entry[0]);
      }
    });
    if (touched.application) url.searchParams.set('application', touched.application);
    else if (ctx.application) url.searchParams.set('application', ctx.application);
    else url.searchParams.delete('application');
    if (!touched.geometry) {
      if (ctx.context) url.searchParams.set('context', ctx.context);
      else url.searchParams.delete('context');
    } else if (ctx.context) {
      var generatedContext = url.searchParams.get('context') || '';
      url.searchParams.set('context', clean([ctx.context, generatedContext].filter(Boolean).join(' | '), 1500));
    }
    ['media','product','product_id','variant','sku','standard','standard_code','standard_class','quantity','resolution_context_id'].forEach(function (key) {
      if (ctx[key]) url.searchParams.set(key, ctx[key]);
    });
    if (ctx.motion) url.searchParams.set('motion', ctx.motion);
    if (ctx.hardware) url.searchParams.set('hardware', ctx.hardware);
    var special = ctx.special;
    var unresolved = [];
    if (ctx.material && !applied.material) unresolved.push('requested material ' + ctx.material);
    if (ctx.hardness && !applied.hardness) unresolved.push('requested hardness ' + ctx.hardness);
    if (ctx.temperature && !touched.temperature) unresolved.push('incoming temperature context ' + ctx.temperature + ' (unit not assumed)');
    if (ctx.pressure && !touched.pressure) unresolved.push('incoming pressure context ' + ctx.pressure + ' (unit not assumed)');
    if (unresolved.length) special = [special, unresolved.join('; ')].filter(Boolean).join(' | ');
    if (special) url.searchParams.set('special', special);
    return url.origin === location.origin ? url.pathname + url.search : url.href;
  }
  function quoteLinks(shadow) {
    return Array.from(shadow.querySelectorAll('a[href]')).filter(function (a) {
      return clean(a.textContent, 100) === 'Request quote' || /\/pages\/bulk-quote(?:\?|$)/.test(a.getAttribute('href') || '');
    });
  }
  function renderSummary(host, ctx, applied) {
    var old = host.previousElementSibling;
    if (old && old.matches('[data-oxx-engineer-context-summary]')) old.remove();
    var items = [];
    if (ctx.id || ctx.cs) items.push('Size: ID ' + (ctx.id || '—') + ' × CS ' + (ctx.cs || '—') + (ctx.unit ? ' ' + ctx.unit : ''));
    if (ctx.material) items.push('Material: ' + ctx.material + (applied.material ? '' : ' (review context)'));
    if (ctx.hardness) items.push('Hardness: ' + ctx.hardness + (applied.hardness ? ' Shore A' : ' (review context)'));
    if (ctx.media) items.push('Media: ' + ctx.media);
    if (!items.length) return;
    var box = document.createElement('aside');
    box.dataset.oxxEngineerContextSummary = '';
    box.setAttribute('aria-label', 'Carried tool context');
    box.style.cssText = 'max-width:1180px;margin:16px auto 0;padding:14px 16px;border:1px solid rgba(20,34,51,.14);border-radius:10px;background:#fff;font-size:14px;line-height:1.5';
    var title = document.createElement('strong'); title.textContent = 'Carried into Engineer Pro';
    var detail = document.createElement('div'); detail.textContent = items.join(' · ');
    var note = document.createElement('small'); note.style.cssText = 'display:block;margin-top:4px';
    note.textContent = 'Only supplied context is carried forward. Unconfirmed example hardware, temperature and pressure values are ignored until you explicitly enter or change them.';
    box.append(title, detail, note);
    host.parentNode.insertBefore(box, host);
  }
  function install() {
    var host = document.querySelector('[data-oxx-engineer-pro-root]');
    if (!host || !host.shadowRoot) return false;
    var shadow = host.shadowRoot;
    if (!shadow.querySelector('#field-ringId') || !shadow.querySelector('#field-cs')) return false;
    if (host.dataset.oxxEngineerContextV2 === 'ready') return true;

    var ctx = parseContext(location.search);
    var applied = applyContext(shadow, ctx);
    var touched = {
      material: false,
      hardness: false,
      temperature: false,
      pressure: false,
      application: '',
      geometry: false
    };
    renderSummary(host, ctx, applied);

    var patching = false;
    function patchQuoteLinks() {
      if (patching) return;
      patching = true;
      quoteLinks(shadow).forEach(function (link) {
        var current = link.getAttribute('href') || '';
        var merged = mergeQuoteContext(current, ctx, applied, touched);
        if (current !== merged) link.setAttribute('href', merged);
      });
      patching = false;
    }
    function markTouched(event) {
      var target = event && event.target;
      if (!target) return;
      var id = target.id || '';
      if (id === 'field-material') touched.material = true;
      if (id === 'field-hardness') touched.hardness = true;
      if (id === 'field-temperature') { touched.temperature = true; touched.temperatureValue = clean(target.value, 200); }
      if (id === 'field-pressure') { touched.pressure = true; touched.pressureValue = clean(target.value, 200); }
      if (['field-bore','field-shaft','field-grooveDepth','field-installedDiameter','field-grooveWidth'].indexOf(id) >= 0) touched.geometry = true;
    }
    var observer = new MutationObserver(function () { setTimeout(patchQuoteLinks, 0); });
    observer.observe(shadow, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
    shadow.addEventListener('input', function (event) { markTouched(event); setTimeout(patchQuoteLinks, 0); }, true);
    shadow.addEventListener('change', function (event) { markTouched(event); setTimeout(patchQuoteLinks, 0); }, true);
    shadow.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (link && /\/pages\/bulk-quote(?:\?|$)/.test(link.getAttribute('href') || '')) {
        root.dataLayer = root.dataLayer || [];
        root.dataLayer.push({ event: 'oxx_engineer_rfq_click', source: ctx.source || 'direct', has_size: Boolean(ctx.id && ctx.cs), has_media: Boolean(ctx.media), application: touched.application || '' });
      }
      var button = event.target && event.target.closest ? event.target.closest('button') : null;
      var label = button ? clean(button.textContent, 80) : '';
      if (['Rod / Shaft','Piston / Bore','Axial Face Seal','Dynamic'].indexOf(label) >= 0) touched.application = label;
      setTimeout(patchQuoteLinks, 0);
    }, true);
    ['Rod / Shaft','Piston / Bore','Axial Face Seal','Dynamic'].forEach(function (label) {
      var button = Array.from(shadow.querySelectorAll('button')).find(function (b) {
        return clean(b.textContent, 80) === label;
      });
      if (button) button.addEventListener('click', function () {
        touched.application = label;
        setTimeout(patchQuoteLinks, 0);
      }, true);
    });
    patchQuoteLinks();

    host.dataset.oxxEngineerContextV2 = 'ready';
    root.dataLayer = root.dataLayer || [];
    root.dataLayer.push({
      event: 'oxx_engineer_context_loaded',
      source: ctx.source || 'direct',
      has_size: Boolean(ctx.id && ctx.cs),
      material_prefilled: applied.material,
      hardness_prefilled: applied.hardness,
      has_media: Boolean(ctx.media)
    });
    return true;
  }

  root.OxxEngineerContextBridgeV2 = {
    parseContext: parseContext,
    mergeQuoteContext: mergeQuoteContext,
    positive: positive,
    install: install
  };
  var attempts = 0;
  function boot() {
    if (install()) return;
    attempts += 1;
    if (attempts < 200) setTimeout(boot, 50);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})(window);
